import {
    temAcesso
} from '@/bibliotecas/seguranca/authLib'

const FaturamentosCredores = () => import('./FaturamentosCredores.vue')
const FaturamentosRecuperadores = () => import('./FaturamentosRecuperadores.vue')

export default {
    path: 'faturamentos',
    name: 'Painel_Faturamentos',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [{
            path: 'credores',
            name: 'Painel_Faturamentos_Credores',
            component: FaturamentosCredores,
            beforeEnter: (to, from, next) => {
                if (temAcesso('PAINEL-FAT-00')) {
                    next()
                }
            }
        },
        {
            path: 'recuperadores',
            name: 'Painel_Faturamentos_Recuperadores',
            component: FaturamentosRecuperadores,
            beforeEnter: (to, from, next) => {
                if (temAcesso('PAINEL-FAT-01')) {
                    next()
                }
            }
        }
    ]
}



// WEBPACK FOOTER //
// ./src/modulos/paineis/faturamentos/FaturamentosRotas.js